import { mapState } from 'vuex'
import TableFilter from '@/components/common/tablefilter/TableFilter.vue'
import ClientListExpand from '@/components/client/listexpand/ClientListExpand.vue'
import UserListExpand from '@/components/user/listexpand/UserListExpand.vue';
import ClientMaterialGroupSettingExpand from '@/components/client/materialgroupsettings/expand/ClientMaterialGroupSettingExpand.vue'
import BankListExpand from '@/components/bank/listexpand/BankListExpand.vue'
import ReportCostTypeExpand from '@/components/reports/costtypeexpand/ReportCostTypeExpand.vue'
import ClientContractListExpand from '@/components/client/contract/listexpand/ClientContractListExpand.vue'
import Filelist from '@/components/common/fileupload/filelist/Filelist.vue'
import AuditListExpand from '@/components/audit/listexpand/AuditListExpand.vue';
import ConfigEmailsMailMessageListExpand from '@/components/configs/emails/mailmessagelistexpand/ConfigEmailsMailMessageListExpand.vue'
import RegenTemplatesListExpand from '@/components/configs/regen/templates/listexpand/RegenTemplatesListExpand.vue'

export default {
  name: 'Tableview',
  props: {
    fields: Array,
    items: Array,
    expandableConfig: Object,
    loading: Boolean,
    filters: Object,
    filterValues: Object,
    exportCols: Array,
    displayFilterActions: {
      type: Boolean,
      default: false
    },
    displayColFiltersAlways: {
      type: Boolean,
      default: false
    },
    displayReload: {
      type: Boolean,
      default: true
    },
    filterActions: {
      type: Object,
      default: function () {
        return { filters: true, reload: true, download: true }
      }
    },
    loadDataOnMounted: {
      type: Boolean,
      default: false
    },
    tableClass: {
      type: String,
      default: ''
    },
    tableSorting: {
      type: Object,
      default: null
    },
    rowClassText: Function,
    rowSummaryLabel: Function,
    localPaging: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 20
    }
  },
  data () {
    return {
      downloading: false,
      displayColFilters: false,
      sortBy: null,
      sortDesc: true,
      paging: { limit: this.perPage, page: 1, pages: 0 },
      localFilters: { }
    }
  },
  components: {
    TableFilter,
    Filelist,
    ClientListExpand,
    UserListExpand,
    ClientMaterialGroupSettingExpand,
    BankListExpand,
    ReportCostTypeExpand,
    ClientContractListExpand,
    AuditListExpand,
    ConfigEmailsMailMessageListExpand,
    RegenTemplatesListExpand
  },
  computed: {
    ...mapState(['config']),
    quickfilters () {
      const res = {};
      for (const key in this.filters) {
        if (!Object.prototype.hasOwnProperty.call(this.filters[key], 'colOnlyFilter') || this.filters[key].colOnlyFilter === false) {
          res[key] = this.filters[key];
        }
      }
      return res;
    },
    hasColFilters () {
      if (this.fields && this.filters) {
        return (this.fields.filter(el => Object.prototype.hasOwnProperty.call(el, 'filterKey')).length > 0);
      }
      return false;
    },
    localFilterFields () {
      const filterFields = {};
      const self = this;
      this.fields.forEach(function (el) {
        if (self.localFilters[el.key]) {
          filterFields[el.key] = el;
        }
      });
      return filterFields;
    },
    filteredItems () {
      const self = this;
      if (this.items) {
        return this.items.filter(function (el) {
          let res = true;
          Object.keys(self.localFilters).forEach(function (filterKey) {
            if (res && self.localFilters[filterKey] && self.localFilterFields[filterKey]) {
              let text = self.BasicHelper.getObjectValueByString(el, filterKey);
              if (self.localFilterFields[filterKey].searchFunc) {
                text = self.localFilterFields[filterKey].searchFunc(text, el, filterKey);
              } else if (text && self.localFilterFields[filterKey].format === 'formatFromConfig') {
                text = self.$options.filters.formatFromConfig(text, self.config[self.localFilterFields[filterKey].configKey], 'name', self.$i18n.locale);
              }
              if (text) {
                if (self.localFilterFields[filterKey].searchExact) {
                  res = (text == self.localFilters[filterKey]);
                } else {
                  res = text.toLowerCase().includes(self.localFilters[filterKey].toLowerCase());
                }
              }
            }
          });
          return res;
        });
      }
      return [];
    },
    tableItems () {
      if (this.loading) {
        return null;
      }
      if (this.localPaging && this.items && this.filteredItems) {
        let resItems = this.filteredItems;
        if (this.sortBy) {
          resItems = this.BasicHelper.sortArrayByKeyValue(resItems, this.sortBy, this.sortDesc);
        }
        this.paging.pages = Math.ceil(this.paging.total / this.paging.limit);
        if (this.paging.pages < this.page) {
          this.paging.page = this.paging.pages;
        }
        if (this.paging.total > this.paging.limit) {
          resItems = resItems.slice((this.paging.page - 1) * this.paging.limit, this.paging.page * this.paging.limit);
        }
        return resItems;
      }
      return this.items;
    }
  },
  methods: {
    toggleRow (item, index, event) {
      if (this.expandableConfig) {
        let allowExpand = true;
        let targetEl = event.target;
        while (targetEl) {
          if (targetEl.className && targetEl.className.includes) {
            if (targetEl.className.includes('table-actions')) {
              allowExpand = false;
              break;
            }
            if (targetEl.className.includes('tableview')) {
              break;
            }
          }
          targetEl = targetEl.parentElement;
        }
        if (allowExpand) {
          item._showDetails = !item._showDetails;
          this.$forceUpdate();
        }
      }
    },
    actionVisible (actionConfig, item) {
      if (actionConfig) {
        if (actionConfig.useFunc) {
          return actionConfig.func(item);
        }
        const paramVal = this.BasicHelper.getObjectValueByString(item, actionConfig.param);
        if (actionConfig.notCheck) {
          if (actionConfig.valueIn) {
            if (!actionConfig.valueIn.find(val => (val == paramVal))) {
              return true;
            }
          } else if (!actionConfig.valueIn && paramVal != actionConfig.value) {
            return true;
          }
        } else {
          if (actionConfig.valueIn) {
            if (actionConfig.valueIn.find(val => (val == paramVal))) {
              return true;
            }
          } else if (paramVal === actionConfig.value) {
            return true;
          }
        }
        return false;
      }
      return true;
    },
    updateFilter (key, value) {
      this.$emit('updateFilter', key, value);
    },
    updateSort (ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.$emit('updateSort', ctx.sortBy, ctx.sortDesc);
    },
    getDateStatusClass (item, key) {
      if (Object.prototype.hasOwnProperty.call(item, key + 'Status')) {
        const elStatus = parseInt(item[key + 'Status']);
        if (elStatus === 2) {
          return ' soon-expire';
        } else if (elStatus === 1) {
          return ' valid';
        }
        return ' expired';
      }
      return '';
    },
    getYesNoClass (value) {
      if (value == 1) {
        return ' valid font-weight-bold';
      }
      return ' error font-weight-bold';
    },
    getRouteParams (item, routeParams) {
      const params = {};
      for (const [key, keyStr] of Object.entries(routeParams)) {
        params[key] = this.BasicHelper.getObjectValueByString(item, keyStr);
      }
      return params;
    },
    isExpandVisible (config, row) {
      if (config.ifconfig) {
        const val = this.BasicHelper.getObjectValueByString(row.item, config.ifconfig.param);
        let res = (val === config.ifconfig.value);
        if (config.ifconfig.notCheck) {
          res = !res;
        }
        return res;
      }
      return true;
    },
    downloadTable (paramSelected) {
      if (!paramSelected && this.exportCols) {
        this.$refs.searchchecklist.showModal();
      } else if (!this.downloading) {
        this.$emit('download', this.$refs.tableview.innerHTML, this.filterValues.exportCols);
      }
    },
    setDownloading (value) {
      this.downloading = value;
    },
    headerColClick (colname, item, e) {
      if (this.hasColFilters) {
        if (colname === 'actions') {
          if (e.target.attributes && e.target.attributes.class && (e.target.attributes.class.value.includes('bi-filter') || e.target.attributes.class.value.includes('table-actions'))) {
            this.displayColFilters = !this.displayColFilters;
            this.$emit('saved');
          }
        } else if (!this.displayColFilters) {
          this.displayColFilters = true;
          this.$emit('saved');
        }
      }
    },
    getTableRowClass (item, type) {
      if (type === 'row' && this.rowClassText) {
        return this.rowClassText(item);
      }
      return '';
    },
    getContractWarningClass (item) {
      let classEl = this.getContractAgreementWarningClass(item);
      classEl = this.ZPFormatHelper.getMaxWarningClass(classEl, this.ZPFormatHelper.getContractWarningClass(item));

      return classEl;
    },
    getContractAgreementWarningClass (item) {
      let agreements = item.agreements;
      if (item.active_agreements) {
        agreements = item.active_agreements;
      }
      let classEl = '';
      const self = this;
      agreements.forEach(agreement => {
        classEl = self.ZPFormatHelper.getMaxWarningClass(classEl, self.ZPFormatHelper.getContractWarningClass(agreement));
      });
      return classEl;
    },
    getFilterValues () {
      const filterVals = {};
      for (const filterKey in this.filters) {
        if (this.filters[filterKey].type === 'checkboxEnabler') {
          if (this.filterValues[filterKey]) {
            for (const filterSub in this.filters[filterKey].sub) {
              filterVals[filterSub] = this.filterValues[filterSub];
            }
          }
        } else {
          if ((!this.displayColFilters && (this.filters[filterKey].colOnlyFilter !== true)) ||
            ((this.displayColFiltersAlways || this.displayColFilters) && (this.filters[filterKey].notWithColFilter !== true))
          ) {
            filterVals[filterKey] = this.filterValues[filterKey];
          }
        }
      }
      filterVals.displayColFilters = this.displayColFilters;
      return filterVals;
    }
  },
  mounted () {
    if (this.tableSorting && this.tableSorting.item) {
      this.sortBy = this.tableSorting.item;
      this.sortDesc = (this.tableSorting.direction === 'DESC');
    } else {
      this.sortBy = null;
      this.sortDesc = true;
    }
    this.displayColFilters = (this.filterValues && this.filterValues.displayColFilters);
    if (this.loadDataOnMounted) {
      this.$emit('saved');
    }
  },
  watch: {
    filteredItems: {
      immediate: true,
      handler (val) {
        if (this.localPaging) {
          this.paging.total = (this.filteredItems ? this.filteredItems.length : 0);
          this.paging.page = 1;
        }
      }
    },
    items: {
      immediate: true,
      handler (val) {
        this.localFilters = {};
      }
    }
  }
}
